// EditKarnetModal.js
import React, { useState, useEffect } from "react";

const EditKarnetModal = ({ isOpen, onClose, karnet, onSave }) => {
  const [formData, setFormData] = useState({
    nazwa: "",
    rodzaj: "Solo EMS",
    data_rozpoczecia: "",
    data_zakonczenia: "",
    ilosc_wejsc: 0,
    ilosc_wejsc_kal: 0,
    aktywny: false,
    cena: 0,
    karnet_oplacone: 0,
    platnosc_rodzaj: "calosc",
    przypomnienie_platnosc: 0,
    ilosc_rat: 0,
    cena_za_rate: 0,
    ilosc_gwiazdek: 0,
    max_gwiazdek: 0,
    notatka: "",
  });
  const [amount, setAmount] = useState(0);
  const token = localStorage.getItem("token"); // Pobierz token z localStorage

  useEffect(() => {
    if (karnet) {
      setFormData({
        nazwa: karnet.nazwa,
        rodzaj: karnet.rodzaj,
        data_rozpoczecia: karnet.data_rozpoczecia.split("T")[0], // Format date for input
        data_zakonczenia: karnet.data_zakonczenia.split("T")[0], // Format date for input
        ilosc_wejsc: karnet.ilosc_wejsc,
        ilosc_wejsc_kal: karnet.ilosc_wejsc_kal,
        aktywny: karnet.aktywny,
        cena: karnet.cena,
        karnet_oplacone: karnet.karnet_oplacone,
        platnosc_rodzaj: karnet.platnosc_rodzaj,
        ilosc_rat: karnet.ilosc_rat,
        cena_za_rate: karnet.cena_za_rate,
        ilosc_gwiazdek: karnet.ilosc_gwiazdek,
        max_gwiazdek: karnet.max_gwiazdek,
        przypomnienie_platnosc: karnet.przypomnienie_platnosc,
        notatka: karnet.notatka || "",
      });
    }
  }, [karnet]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    const updatedKarnet = {
      ...karnet,
      karnet_oplacone: karnet.karnet_oplacone + parseFloat(amount),
      ...formData, // Include other form data
    };
    onSave(updatedKarnet);
    setAmount(0); // Reset amount
    onClose(); // Close modal
  };

  if (!isOpen) return null;

  // ... existing code ...

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-11/12 md:w-2/3 max-h-[90vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Edytuj Karnet</h2>
        <form onSubmit={handleSubmit}>
          {/* Komunikaty przeniesione do AllKarnets */}
          {/* Basic Information */}
          <fieldset className="border rounded-md p-4 mb-6">
            <legend className="font-semibold px-2">
              Podstawowe informacje
            </legend>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Nazwa:
                </label>
                <input
                  type="text"
                  name="nazwa"
                  value={formData.nazwa}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Rodzaj:
                </label>
                <select
                  name="rodzaj"
                  value={formData.rodzaj}
                  onChange={handleChange}
                  className="mt-1 block w-full border border-gray-300 rounded-md p-2"
                >
                  <option value="Solo EMS">Solo EMS</option>
                  <option value="Para EMS">Para EMS</option>
                  <option value="Para Personalny">Para Personalny</option>
                  <option value="Solo Personalny">Solo Personalny</option>
                  <option value="Hybryda">Hybryda</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Data Rozpoczęcia:
                </label>
                <input
                  type="date"
                  name="data_rozpoczecia"
                  value={formData.data_rozpoczecia}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Data Zakończenia:
                </label>
                <input
                  type="date"
                  name="data_zakonczenia"
                  value={formData.data_zakonczenia}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </fieldset>

          {/* Details */}
          <fieldset className="border rounded-md p-4 mb-6">
            <legend className="font-semibold px-2">
              Szczegółowe informacje
            </legend>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Ilość Wejść:
                </label>
                <input
                  type="number"
                  name="ilosc_wejsc"
                  value={formData.ilosc_wejsc}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Ilość Wejść na zapisy:
                </label>
                <input
                  type="number"
                  name="ilosc_wejsc_kal"
                  value={formData.ilosc_wejsc_kal}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Ilość Gwiazdek:
                </label>
                <input
                  type="number"
                  name="max_gwiazdek"
                  value={formData.max_gwiazdek}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            <div className="mb-4 flex items-center gap-2">
              <label className="text-sm font-medium text-gray-700">
                Aktywny:
              </label>
              <input
                type="checkbox"
                name="aktywny"
                checked={formData.aktywny}
                onChange={(e) =>
                  handleChange({
                    target: { name: "aktywny", value: e.target.checked },
                  })
                }
                className="mt-1"
              />
            </div>
          </fieldset>

          {/* Payment Information */}
          <fieldset className="border rounded-md p-4 mb-6">
            <legend className="font-semibold px-2">
              Informacje o płatności
            </legend>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Cena:
                </label>
                <input
                  type="number"
                  name="cena"
                  value={formData.cena}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">
                  Opłacone:
                </label>
                <input
                  type="number"
                  name="karnet_oplacone"
                  value={formData.karnet_oplacone}
                  onChange={handleChange}
                  required
                  className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Rodzaj Płatności:
              </label>
              <select
                name="platnosc_rodzaj"
                value={formData.platnosc_rodzaj}
                onChange={handleChange}
                className="mt-1 block w-full border border-gray-300 rounded-md p-2"
              >
                <option value="calosc">Całość</option>
                <option value="rata">Raty</option>
              </select>
            </div>

            {formData.platnosc_rodzaj === "rata" && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Ilość Rat:
                  </label>
                  <input
                    type="number"
                    name="ilosc_rat"
                    value={formData.ilosc_rat}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>

                <div className="mb-4">
                  <label className="block text-sm font-medium text-gray-700">
                    Cena za Ratę:
                  </label>
                  <input
                    type="number"
                    name="cena_za_rate"
                    value={formData.cena_za_rate}
                    onChange={handleChange}
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                </div>
              </div>
            )}

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700">
                Przypomninie o płatnosci (ilosć treningow):
              </label>
              <input
                type="number"
                name="przypomnienie_platnosc"
                value={formData.przypomnienie_platnosc}
                onChange={handleChange}
                required
                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
              />
            </div>
          </fieldset>

          {/* Notatka */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700">
              Notatka:
            </label>
            <textarea
              name="notatka"
              value={formData.notatka}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Wprowadź notatkę"
            />
          </div>

          <div className="flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-black px-6 py-2 rounded hover:bg-gray-400 transition-colors"
            >
              Anuluj
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 transition-colors"
            >
              Zapisz
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  // ... existing code ...
};

export default EditKarnetModal;
